import { useSearchParams, useNavigate } from 'react-router-dom';
import { QRCodeCanvas } from 'qrcode.react';
import { Button } from '../../components/ui/button';
import { Printer, ArrowLeft, Shield } from 'lucide-react';
import { format, parseISO } from 'date-fns';

const BASE_URL = process.env.REACT_APP_BACKEND_URL?.replace('/api', '').replace(/\/$/, '') || window.location.origin;

export default function PrintBadgePage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const code = searchParams.get('code') || '';
  const location = searchParams.get('location') || '';
  const dates = searchParams.get('dates')?.split(',') || [];
  const startTime = searchParams.get('start_time') || '';
  const endTime = searchParams.get('end_time') || '';

  const feedbackUrl = `${BASE_URL}/feedback/${code}`;

  return (
    <div className="min-h-screen bg-background">
      {/* Controls - hidden when printing */}
      <div className="p-4 flex gap-3 print:hidden border-b border-border">
        <Button variant="outline" onClick={() => navigate(-1)} className="border-border rounded-sm">
          <ArrowLeft className="w-4 h-4 mr-2" /> Back
        </Button>
        <Button onClick={() => window.print()} className="bg-primary text-primary-foreground hover:bg-yellow-300 rounded-sm">
          <Printer className="w-4 h-4 mr-2" /> Print Badge
        </Button>
      </div>

      {/* Badge - printable area */}
      <div className="flex justify-center p-8 print:p-4 print:justify-start">
        <div
          className="border-2 border-black bg-white text-black"
          style={{ width: 400, pageBreakInside: 'avoid' }}
          data-testid="qr-badge"
        >
          {/* Top bar */}
          <div className="bg-black text-white py-4 px-6 text-center">
            <div className="flex items-center justify-center gap-2">
              <Shield className="w-5 h-5" />
              <h1 className="text-2xl font-bold tracking-[0.3em] uppercase">Security</h1>
            </div>
          </div>

          {/* Event details */}
          <div className="px-6 py-4 border-b border-gray-300">
            <p className="text-base font-bold text-center">{location}</p>
          </div>

          {/* QR Code - large canvas for crisp print */}
          <div className="px-4 pt-6 pb-2 flex justify-center">
            <QRCodeCanvas
              value={feedbackUrl}
              size={340}
              level="M"
              includeMargin={true}
              style={{ width: 340, height: 340, imageRendering: 'pixelated' }}
            />
          </div>
          <div className="pb-6 text-center">
            <p className="text-base font-bold tracking-widest uppercase text-black">Personal Feedback</p>
            <p className="text-[10px] text-gray-400 mt-1 font-mono">{code}</p>
          </div>
        </div>
      </div>

      {/* Print styles */}
      <style>{`
        @media print {
          body { margin: 0; padding: 0; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
          @page { size: auto; margin: 10mm; }
          canvas { image-rendering: pixelated !important; }
        }
      `}</style>
    </div>
  );
}
